module.exports = __webpack_public_path__ + "static/media/main_visual_skid_steer_loaders_2200_r_manitou.ae0a6bca.png";